export type TaskListModel = {
  id?: number,
  ad_hoc?: boolean,
  brand_id?: number,
  cache_key?: number,
  checklist_score?: {
    available_points: number,
    failed_points: number,
    received_points: number,
  },
  checklist_template_id?: number,
  completed?: boolean,
  data?: {
    template_project?: boolean,
  },
  dates?: {
    due: {
      date_time: string,
      integer: number,
    },
  },
  debtor_id?: number,
  debtor_type?: string,
  due_date?: string,
  hidden?: boolean,
  owner_id: number,
  owner_type: string,
  notification_emails?: string[],
  notification_frequency?: 'never' | 'daily' | 'weekly',
  progress_status?: string, // readonly
  subject_id: number,
  subject_type: string,
  task_list_template_id?: number,
  template_checklist?: boolean,
  template_project?: boolean,
  template_version?: string,
  title?: string,
  type?: string,
  user_id?: number,
  workflow?: boolean,
}

export type TaskListRequestOptions = {
  include_task_list_items?: boolean,
  include_task_list_progress_status?: boolean,
  include_task_list_sections?: boolean,
}

const state = {
  id: undefined,
  ad_hoc: false,
  checklist_template_id: undefined,
  completed: false,
  debtor_type: undefined,
  debtor_id: undefined,
  due_date: '',
  hidden: false,
  notification_emails: [],
  notification_frequency: '',
  owner_id: undefined,
  owner_type: '',
  subject_id: undefined,
  subject_type: '',
  task_list_template_id: undefined,
  template_checklist: false,
  template_project: true,
  template_version: '',
  title: '',
  user_id: undefined,
  workflow: false,
}

export const requiredFields = [
  { key: 'title' },
]

export default state
